import messages from '../../../../locale/messages';

const validate = (values) => {
    const errors = {};

    if (!values.locationName || !values.locationName.trim()) {
        errors.locationName = messages.required;
    }

    if (!values.description || !values.description.trim()) {
        errors.description = messages.required;
    }

    return errors;
};

export default validate;
